<template>
  <!-- 今日线索信息 -->
  <el-row :gutter="5" class="row_item">
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <MyleadsToday :title="'今日线索'"/>
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <MyleadsTomorrow :title="'昨日线索'"/>
    </el-col>
  </el-row>

  <el-row :gutter="5" class="row_item">
    <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
      <MyleadsWeek :title="'本周线索'"/>
    </el-col>
    <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
      <MyleadsMonth :title="'本月线索'"/>
    </el-col>
  </el-row>
  <el-row :gutter="5" class="row_item">
    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
      <MyleadsList :title="'线索记录'"/>
    </el-col>
  </el-row>

  
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import MyleadsToday from './components/myleads_today.vue'
import MyleadsTomorrow from './components/myleads_tomorrow.vue'
import MyleadsWeek from './components/myleads_week.vue'
import MyleadsMonth from './components/myleads_month.vue'
import MyleadsList from './components/myleads_list.vue'



</script>

<style scoped>
@import "./statistics-index.scss";
</style>